/**
 * 常用的字符串处理方法
 * @author
 * @date
 */
export const StringUtils = (function() {
    // 字符串去掉两边空白正则表达式
    let trimRegex = /^[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+|[\x09\x0a\x0b\x0c\x0d\x20\xa0\u1680\u180e\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200a\u2028\u2029\u202f\u205f\u3000]+$/g,

        // 字符串格式化正则表达式
        formatRegex = /\{(\d+)\}/g,

        htmlEncodeMap = {
            '"': "&quot;",
            '&': "&amp;",
            "'": "&#39;",
            '<': "&lt;",
            '>': "&gt;"
        },

        htmlDecodeMap = {
            '&#39;': "'",
            '&amp;': "&",
            '&gt;': ">",
            '&lt;': "<",
            '&quot;': '"'
        },

        htmlEncodeRegex = /(&|>|<|"|')/g,

        htmlDecodeRegex = /(&amp;|&gt;|&lt;|&quot;|&#39;|&#[0-9]{1,5};)/g;

    function pad(num, n) {
        return Array(n>num?(n-(''+num).length+1):0).join('0')+num;
    }

    return {

        /**
         * batTermSn
         * @param   txt  {String}  字符串
         * @return  {total: number, tsnLst: null}
         */
        batTermSn: function(txt) {
            let respData = {total:0,tsnLst:null};
            let tsnLst = [];
            let rowLstTemp = [];
            let rowLst = [];
            let devCnt = 0;

            rowLstTemp = txt.split(/[\n\r]+/); // 以换行分割，不包含空行

            for(let i=0;i<rowLstTemp.length;i++) {
                let rowTxt = rowLstTemp[i];
                rowTxt = rowTxt.replace(/\s+/g,""); // 删除每行内全部空格
                if(rowTxt.length>0) {
                    rowLst.push(rowTxt);
                }
            }

            if(rowLst.length>0) {
                let sns = rowLst;
                for(let i=0;i<sns.length;i++) {
                    if(sns[i]) {
                        if(sns[i].indexOf("-")!==-1) {
                            let sn_sn = sns[i].split("-");
                            if(sn_sn.length===2 && sn_sn[0].length===sn_sn[1].length) {
                                let len = sn_sn[0].length;
                                let sn1 = sn_sn[0];
                                let sn2 = sn_sn[1];
                                let idx = -1;
                                for(let j=len-1;j>=0;j--) {
                                    if( sn1.charCodeAt(j)>=48 && sn1.charCodeAt(j)<=57
                                        && sn2.charCodeAt(j)>=48 && sn2.charCodeAt(j)<=57 ) {
                                        idx = j; // 从后向前最后一个数字
                                    }
                                    else break;
                                }
                                if(idx>=0) {

                                    let sn1Header = sn1.substring(0,idx);
                                    let sn2Header = sn2.substring(0,idx);
                                    let sn1Tail = sn1.substring(idx);
                                    let sn2Tail = sn2.substring(idx);

                                    if(sn1Header===sn2Header && sn1Tail.length===sn2Tail.length) {

                                        let snc = sn2Tail-sn1Tail;

                                        if(snc<0)
                                            return null;

                                        devCnt += sn2Tail-sn1Tail+1;

                                        if(devCnt>3000) return null; // 批量提交不大于3000

                                        let tailLen = sn1Tail.length;

                                        for(let k=0;k<=snc;k++) {
                                            let snTail = Number.parseInt(sn1Tail)+k;
                                            let sn = '00000000000000000000000000000000000000000000000000'+snTail;
                                            sn = sn.substring(sn.length-tailLen);
                                            tsnLst.push(sn1Header+sn);
                                        }
                                    }
                                    else return null;
                                }
                                else return null;
                            }
                            else return null;
                        }
                        else {
                            devCnt++;
                            if(devCnt>3000) return null; // 批量提交不大于3000
                            tsnLst.push(sns[i]);
                        }
                    }
                }
            }
            console.log('数量：'+devCnt);
            console.log(JSON.stringify(tsnLst));

            respData.tsnLst = tsnLst;
            respData.total = devCnt;

            return respData;
        },

        /**
         * 除去字符串两端的空白字符
         * @param   str  {String}  字符串
         * @return  返回处理后的字符串
         */
        trim: function(str){
            return str.replace(trimRegex, '');
        },

        /**
         * 允许用格式化的方式给传值
         * let cls = 'css-class', text = '内容';
         * let str = Rhui.String.format('<div class="{0}">{1}</div>', cls, text);
         * // str的内容是 <div class="css-class">内容</div>
         *
         * @param  str        {String}  待格式化的字符串
         * @param  params...  {Object}  与字符串中{0}、{1}...匹配的内容
         * @return 返回格式化后的字符串
         */
        format: function(str) {
            let i, args = arguments, len = args.length, arr = [];
            for(i = 1; i < len; i++){
                arr.push(args[i]);
            }

            return str.replace(formatRegex, function(m, i) {
                return arr[i];
            });
        },

        /**
         * 填补字符串左边
         * @param   str        {String}  原字符串
         * @param   size       {Number}  填补后的长度
         * @param   character  {String}  填补的字符，如果不填则为空字符' '
         * @return  返回填补后的字符串
         */
        leftPad: function(str, size, character) {
            let result = '' + str;

            if(Object.prototype.toString.call(character) !== '[object String]'){
                character = ' ';
            }

            while (result.length < size) {
                result = character + result;
            }

            return result;
        },

        /**
         * 填补字符串右边
         * @param   str        {String}  原字符串
         * @param   size       {Number}  填补后的长度
         * @param   character  {String}  填补的字符，如果不填则为空字符' '
         * @return  返回填补后的字符串
         */
        rightPad: function(str, size, character) {
            let result = '' + str;

            if(Object.prototype.toString.call(character) !== '[object String]'){
                character = ' ';
            }

            while (result.length < size) {
                result += character;
            }

            return result;
        },

        /**
         * 把字符串中的html字符转义
         * @param   str  {String}
         * @return  返回转义后的字符
         */
        htmlEncode: function(str) {
            if(Object.prototype.toString.call(str) === '[object String]'){
                return str.replace(htmlEncodeRegex, function(match, val){
                    return htmlEncodeMap[val];
                });
            }else{
                return str;
            }
        },

        /**
         * 把字符串中的html字符解码
         * @param   str  {String}
         * @return  返回解码后的字符串
         */
        htmlDecode: function(str) {
            if(Object.prototype.toString.call(str) === '[object String]'){
                return str.replace(htmlDecodeRegex, function(match, val){
                    return htmlDecodeMap[val];
                });
            }else{
                return str;
            }
        }
    };
})();